import React from "react";
import styles from "./index.module.css";
import { useSelector } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";

const SystemReport = ({ children, onDownload, onDownloadExcel, title, index, type, id }) => {
  const { loading, updatingId } = useSelector((store) => store.yourReports);

  return (
    <div className={styles["container"]}>
      {updatingId === id ? (
        <PulseLoader />
      ) : (
        <>
          {" "}
          <p>{children}</p>
          <div style={{ display: 'flex', gap: '1rem' }}>
          <div
            className={styles["btn"]}
            data-title={title}
            onClick={onDownload}
            data-index={index}
            data-type={type}
          >
              <span>Download PDF</span>
            <i className="bi bi-download"></i>
            </div>
            <div
              className={styles["btn"]}
              data-title={title}
              onClick={onDownloadExcel}
              data-index={index}
              data-type={type}
            >
              <span>Download Excel</span>
              <i className="bi bi-file-earmark-excel"></i>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SystemReport;
